import React from "react";
const severityLevels = [{
  id: "low",
  label: "Low",
  range: "0–20",
  colorClass: "bg-slate-500",
  textColor: "text-white",
  description: "Minimal pressure. Conditions are stable with limited signs of strain."
}, {
  id: "moderate",
  label: "Moderate",
  range: "21–40",
  colorClass: "bg-emerald-500",
  textColor: "text-white",
  description: "Manageable levels. Some movement above baseline; monitoring is recommended."
}, {
  id: "elevated",
  label: "Elevated",
  range: "41–60",
  colorClass: "bg-amber-500",
  textColor: "text-white",
  description: "Noticeable strain. Precautionary measures or closer observation are advised."
}, {
  id: "high",
  label: "High",
  range: "61–80",
  colorClass: "bg-red-600",
  textColor: "text-white",
  description: "Significant stress. Active management or intervention may be required."
}, {
  id: "extreme",
  label: "Extreme",
  range: "100+",
  colorClass: "bg-rose-900",
  textColor: "text-white",
  description: "Conditions have surpassed the calibrated index range, indicating extraordinary or compounding pressures beyond typical environments."
}];
export default function IndexSeverityScale() {
  return <section id="indexseverityscale" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-default font-semibold text-foreground mb-4">
            Understanding your index score
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-sans">
            The Australian Index Bureau utilizes a standardized 0–100 scale across all indicators to ensure statistical consistency. While most readings fall within this primary range, scores exceeding 100 represent exceptional stress levels that have moved beyond historical baselines, requiring immediate attention and specialized mitigation strategies.
          </p>
        </div>

        <div className="relative w-full mt-8">
          <div className="flex w-full h-16 md:h-20 rounded-md overflow-hidden shadow-sm border border-border/50">
            {severityLevels.map((level, i) => <div key={level.id} data-index={i} className={`flex-1 flex flex-col items-center justify-center transition-opacity hover:opacity-95 ${level.colorClass}`}>
                <span className={`text-sm md:text-base font-semibold tracking-wide ${level.textColor}`}>
                  {level.label}
                </span>
              </div>)}
          </div>

          <div className="flex w-full justify-between mt-4 text-xs md:text-sm text-muted-foreground font-mono">
            {severityLevels.map((level, i) => <div key={`range-${level.id}`} data-index={i} className="flex-1 flex flex-col items-center relative">
                <div className="absolute -top-4 left-1/2 w-px h-3 bg-border -translate-x-1/2"></div>
                <span className="font-medium text-foreground mt-1">{level.range}</span>
                <span className="text-[10px] md:text-xs text-center mt-1 hidden md:block opacity-70 font-sans">
                  {level.description}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}